export default "__VITE_ASSET__fYklvnj2__"